import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';
import { TABLE_FIELDS } from 'utils/constants';

/**
 * this api import table fields from a csv file
 * @param {number} idProtocol current program ID
 * @param {number} idFieldGroup doctype
 * @param {string} base64Csv base64 string
 * @return {Promise<AxiosResponse>}
 */
export interface ITableFields {
  [key: string]: {
    confidence: number;
    content: string;
    pageNumber: number;
    boundingBox: {
      x1: number;
      y1: number;
      x2: number;
      y2: number;
    };
  };
}
export interface ITableFieldsResponse {
  protocol: number;
  idUser: number;
  idColumn: number;
  rowNumber: number;
  idFieldGroup: number;
  content: string;
  x1: number;
  x2: number;
  y1: number;
  y2: number;
  pageNumber: number;
  confidence: number;
  defaults: boolean;
}

// function that converte a a body like ITableFieldsResponse to ITableFields filtered by rowNumber
const convertTableFieldsResponseToTableFields = (tableFieldsResponse: ITableFieldsResponse[]): ITableFields[] => {
  const tableFields: ITableFields[] = [];
  tableFieldsResponse.forEach((tableFieldResponse) => {
    if (!tableFields[tableFieldResponse.rowNumber]) {
      tableFields[tableFieldResponse.rowNumber] = {};
    }
    tableFields[tableFieldResponse.rowNumber][tableFieldResponse.idColumn] = {
      confidence: tableFieldResponse.confidence,
      content: tableFieldResponse.content,
      pageNumber: tableFieldResponse.pageNumber,
      boundingBox: {
        x1: tableFieldResponse.x1,
        y1: tableFieldResponse.y1,
        x2: tableFieldResponse.x2,
        y2: tableFieldResponse.y2,
      },
    };
  });
  return tableFields;
};

/**
 * this api import table fields from a csv file
 * @param {number} idProtocol current program ID
 * @param {number} idFieldGroup doctype
 * @param {string} base64Csv base64 string
 * @return {Promise<AxiosResponse>}
 */

const importTableFields = async (idProtocol: number, idFieldGroup: number, base64Csv: string) => {
  const response = await trackPromise(
    axios.post<ITableFieldsResponse[]>(`${TABLE_FIELDS}/importTableFieldsFromCsv`, {
      idProtocol,
      idFieldGroup,
      base64Csv,
    }),
  );
  return convertTableFieldsResponseToTableFields(response.data);
};

/**
 * this api get csv template for create table fields
 * @param {number} idCompany current Id of Company
 * @param {number} idFieldGroup field group
 * @param {number} idDocType doctype
 * @return {<AxiosResponse<string>>}
 */

const getCsvForCreateTableFields = async (idCompany: number, idFieldGroup: number, idDocType: number) =>
  await trackPromise(
    axios.post<string>(`${TABLE_FIELDS}/getCsvTemplateForCreateTableFields`, {
      idCompany,
      idFieldGroup,
      idDocType,
    }),
  );

export default { importTableFields, getCsvForCreateTableFields };
